module.exports = __webpack_public_path__ + "img/alert.0d109a4c.gif";